import type { AdmissionOfficeCountry } from "../../admissionOfficeCountry";
import {
  listMaltaEnAdmissionSignatures,
  templatesMaltaEnAdmissionCoursesSettings,
  templatesMaltaEnInvoiceCoursesSettings,
} from "@/src/constants/AdmissionOffice/Malta/AOMaltaEnConsts";
import {
  listPolandEnAdmissionSignatures,
  templatesPolandEnAdmissionCoursesSettings,
  templatesPolandEnInvoiceCoursesSettings,
} from "@/src/constants/AdmissionOffice/Poland/AOPolandEnConsts";
import {
  listUkraineEnAdmissionSignatures,
  templatesUkraineEnAdmissionCoursesSettings,
  templatesUkraineEnInvoiceCoursesSettings,
} from "@/src/constants/AdmissionOffice/Ukraine/AOPUkraineEnConsts";
import type {
  AdmissionLetterBasicCourseTemplate,
  AdmissionLetterBasicInvoiceCourseTemplate,
  AdmissionLetterBasicRegistryEntry,
} from "../AdmissionLetterBasic/admissionLetterBasicRegistry";

export type InvoiceLetterBasicRegistryEntry = AdmissionLetterBasicRegistryEntry;

export const INVOICE_LETTER_BASIC_REGISTRY: Record<AdmissionOfficeCountry, InvoiceLetterBasicRegistryEntry> = {
  malta: {
    signatures: listMaltaEnAdmissionSignatures,
    admissionCourses: templatesMaltaEnAdmissionCoursesSettings as Record<string, AdmissionLetterBasicCourseTemplate>,
    invoiceCourses: templatesMaltaEnInvoiceCoursesSettings as Record<string, AdmissionLetterBasicInvoiceCourseTemplate>,
  },
  poland: {
    signatures: listPolandEnAdmissionSignatures,
    admissionCourses: templatesPolandEnAdmissionCoursesSettings as Record<string, AdmissionLetterBasicCourseTemplate>,
    invoiceCourses: templatesPolandEnInvoiceCoursesSettings as Record<string, AdmissionLetterBasicInvoiceCourseTemplate>,
  },
  ukraine: {
    signatures: listUkraineEnAdmissionSignatures,
    admissionCourses: templatesUkraineEnAdmissionCoursesSettings as Record<string, AdmissionLetterBasicCourseTemplate>,
    invoiceCourses: templatesUkraineEnInvoiceCoursesSettings as Record<string, AdmissionLetterBasicInvoiceCourseTemplate>,
  },
};
